import React, { Suspense, useEffect, useState } from "react";
import AuthContext from "../../hooks/AuthContext";

const SectionZone = React.lazy(() => import("../../pages/home/SectionZone"));
const Stand = React.lazy(() => import("./pontoVenda/Stand"));
const FooterInfo = React.lazy(() => import("./FooterInfo"));
const FooterEmpresa = React.lazy(() => import("./infoEmpresa/FooterEmpresa"));

export default function Footer({ infoJson, allinfoText }) {
  const { state } = React.useContext(AuthContext);
  const [alltexto, setAlltexto] = useState({
    Titulo: "",
    SubTitulo: "",
    Zona: "",
    Url: "",
  });

  useEffect(() => {
    allinfoText.Localizacao && setAlltexto(allinfoText.Localizacao);
  }, [allinfoText]);

  return (
    <>
      <Suspense fallback={<></>}>
        {infoJson.Layout.PontosVenda.existe && (
          <>
            <SectionZone
              Titulo={
                alltexto.Titulo !== "" ? alltexto.Titulo : "Onde estamos?"
              }
              SubTitulo={
                alltexto.SubTitulo !== "" ? alltexto.SubTitulo : "Visite-nos!"
              }
            >
              <Stand infoJson={infoJson} />
            </SectionZone>
          </>
        )}
        {state.infoPrincipal.length !== 0 && (
          <>
            <FooterEmpresa
              allinfo={state.infoPrincipal[0]}
              infoJson={infoJson}
              allinfoText={allinfoText}
            />
            <FooterInfo
              allinfo={state.infoPrincipal[0]}
              infoJson={infoJson}
              allinfoText={allinfoText}
            />
          </>
        )}
      </Suspense>
    </>
  );
}
